import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectOfferingsMode = createSelector(
  [selectConfigurationState],
  ({ isNewOfferings }) => isNewOfferings
)
